import { markCaseAsRead } from '@/backend/case'
import type { MarkCaseAsRead } from '@/backend/caseTypes'
import { useUnreadCases } from '@/data/Cases/useUnreadCases'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import { useMutation, type UseMutationOptions } from '@tanstack/vue-query'

export const useMarkAsRead = (
  options: UseMutationOptions<MutationReturn, Error, string, unknown> = {},
) => {
  const { workspaceId } = useWorkspaceContext()

  const unreadCasesQuery = useUnreadCases({ disabled: true })

  return useMutation({
    mutationFn: async (caseId: string) => {
      const res = await markCaseAsRead({ workspaceId: workspaceId.value, caseId })

      if (!res.ok) {
        throw new Error(res.error.code)
      }

      return res.data
    },
    onSuccess: (data) => {
      unreadCasesQuery.markAsRead(data.id)
    },
    ...options,
  })
}

type MutationReturn = MarkCaseAsRead['successResponse']
